import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { getMappedRecipeImage } from '../../utils/recipeImages';

const getProp=(obj,keys)=> {
  if (!obj) return "";
  const lowerKeys=keys.map(k=> k.toLowerCase());
  for (const key of Object.keys(obj)) {
    if (lowerKeys.includes(key.toLowerCase())) {
      return obj[key];
    }
  } 
  return "";
};

const RecipeCard=({recipe})=> {
  const [imgError,setImgError]=useState(false);
  if (!recipe) return null;

  const rawTags=getProp(recipe,['tags','tag']);
  let tags=[];
  if (Array.isArray(rawTags)) {
    tags=rawTags.map(t=> String(t).trim()).filter(Boolean);
  } else if (typeof rawTags==='string') {
    tags=rawTags.split(',').map(t=> String(t).trim()).filter(Boolean);
  }

  const recipeName=String(getProp(recipe,['name','title']) || "Untitled Recipe");
  const recipeSlug=String(getProp(recipe,['slug','id']) || Math.random().toString(36).substr(2,9));
  const recipeCategory=String(getProp(recipe,['category']) || "Uncategorized");
  const recipeCollection=String(getProp(recipe,['collection','product','made_with']) || "");
  const recipeTime=String(getProp(recipe,['time','prepTime','cookTime']) || "-- mins");
  
  const imagePath = recipe.image_path || '/assets/recipes/';
  const imageFilename = recipe.image_filename || '';
  
  // Restored lookup: Check map first, then local path
  const recipeImage = getMappedRecipeImage(
    imageFilename, 
    imageFilename ? `${imagePath}${imageFilename}` : null
  );

  return (
    <Link to={`/recipes/${recipeSlug}`} className="group flex flex-col h-full bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300" >
      <div className="relative aspect-[4/3] overflow-hidden bg-ube/5 flex items-center justify-center">
        {!imgError && recipeImage ? (
          <img 
            src={recipeImage} 
            alt={`${recipeName} made with UBEA ube`} 
            loading="lazy" 
            onError={()=> setImgError(true)} 
            className="w-full h-full object-cover object-center absolute inset-0 group-hover:scale-105 transition-transform duration-700 ease-in-out z-10" 
          />
        ) : (
          <div className="absolute inset-0 bg-ube/10 flex items-center justify-center">
            <span className="font-serif text-ube/20 text-xl tracking-widest uppercase">UBEA</span>
          </div>
        )}
        {recipeCollection && (
          <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] font-bold text-ube-dark uppercase tracking-wide shadow-sm z-20"> 
            {recipeCollection} 
          </div>
        )}
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-center space-x-2 text-[10px] text-gray-400 mb-2 uppercase tracking-widest font-bold">
          <span>{recipeCategory}</span>
        </div>
        <h3 className="font-serif text-xl text-gray-900 group-hover:text-ube transition-colors leading-tight mb-3">
          {recipeName}
        </h3>
        <div className="flex flex-wrap gap-1 mb-4">
          {tags.slice(0,2).map((tag,i)=> (
            <span key={i} className="text-[9px] text-gray-400 border border-gray-100 px-2 py-0.5 rounded-full lowercase">
              #{String(tag).replace(/\s+/g,'')}
            </span>
          ))}
          {tags.length > 2 && <span className="text-[9px] text-gray-300">+{tags.length - 2}</span>}
        </div>
        <div className="mt-auto pt-4 border-t border-gray-50 flex items-center justify-between">
          <span className="text-xs text-gray-400 flex items-center gap-1">
            <SafeIcon name="Clock" className="w-3 h-3" /> {recipeTime}
          </span>
          <div className="text-xs text-ube font-bold flex items-center group-hover:translate-x-1 transition-transform">
            Recipe <SafeIcon name="ArrowRight" className="w-3 h-3 ml-1" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default RecipeCard;